import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import { isSignedIn } from "seneca-common/features/user/state";

import {
  getXpQueryOptions,
  getXpRewardsQueryOptions,
  UserXpQueryOptions
} from "./queries";

export function useGetUserXp(options?: UserXpQueryOptions) {
  const signedIn = useSelector(isSignedIn);
  return useQuery({
    ...getXpQueryOptions(options),
    enabled: signedIn
  });
}

export function useGetXpRewards() {
  const signedIn = useSelector(isSignedIn);
  return useQuery({
    ...getXpRewardsQueryOptions(),
    enabled: signedIn
  });
}
